import {useCallback} from "react";
import {updatePassword} from "aws-amplify/auth";
import {useNavigate} from "react-router-dom";
import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo
} from "react-icons/ai";

interface ChangePasswordFormFields {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export const useChangePasswordForm = () => {

    const navigate = useNavigate();

    const initialValues: ChangePasswordFormFields = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    };

    const submitForm = async (values: ChangePasswordFormFields) => {

        try {

            await updatePassword({
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            });

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    'event': 'change_password',
                });
            }

            showNotification({
                title: 'Password Updated',
                icon: <AiOutlineInfo/>,
                message: 'Your password has been changed successfully.',
                color: 'teal',
            });

            navigate('/account');

        } catch (e: unknown) {
            console.error(e);

            showNotification({
                title: 'Error',
                icon: <AiOutlineExclamation/>,
                message: e instanceof Error ? e.message : 'An error occurred',
                color: 'red',
            });
        }

    };

    const handleSubmit = useCallback(
        (values: ChangePasswordFormFields) => {
            return submitForm(values)
                .then(() => {
                    console.log('Form submitted!');
                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return {
        initialValues,
        handleSubmit,
    };
};
